import { MutationCache, QueryCache, QueryClient } from '@tanstack/react-query';
import { logger } from 'src/util/logger';

export type QueryMeta = { companyKeys?: string[] } | undefined;

const queryCache = new QueryCache({
  onError: (error) => logger.error(error),
});

const mutationCache = new MutationCache({
  onError: (error, variables) => {
    logger.error(error);
    logger.info('Variables: ', variables);
  },
});

queryCache.subscribe((event) => {
  const {
    type,
    query: { state, queryHash },
  } = event;
  if (['added', 'removed', 'updated'].includes(event.type)) {
    logger.log('Query: ', { type, queryHash, state });
  }
});

mutationCache.subscribe((event) => {
  if (!event.mutation) return;

  const { options, state, mutationId } = event.mutation;

  if (state.data && ['added', 'removed', 'updated'].includes(event.type)) {
    logger.log('Mutation: ', { mutationId, options, state });
  }
});

export const queryClient = new QueryClient({
  queryCache,
  mutationCache,
  defaultOptions: {
    queries: {
      networkMode: 'offlineFirst',
      staleTime: 1 * 60 * 1000, // 1 min
    },
    mutations: {
      networkMode: 'always',
    },
  },
});
